import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors} from '@angular/common/http';
import { tokenInterceptorInterceptor } from '@interceptors/token-interceptor.interceptor';
import { LOCALE_ID } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ValidTokenInterceptor } from '@interceptors/valid-token.interceptor';
import { registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';


registerLocaleData(localeEsCl);

import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts';

export const appConfig: ApplicationConfig = {
  providers: [
    DecimalPipe,
    { provide: LOCALE_ID, useValue: 'es-CL' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([tokenInterceptorInterceptor, ValidTokenInterceptor])
    ),
    provideEchartsCore({ echarts }),
  ]
};

